import styled from "styled-components";

export const Card = styled.div`
    background-color: white;
    border-radius: 16px;
`;
